// extracted by mini-css-extract-plugin
var _1 = "bKlCvg3wdKhRWs1m2KQT";
export { _1 as "root" }
